import React, { useState } from 'react';
import { Menu, X, Globe } from 'lucide-react';
import { Button } from './ui/button';
import { useLanguage } from '../context/LanguageContext';

const Header = ({ scrollToSection }) => {
  const { lang, t, toggleLanguage } = useLanguage();
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const handleNav = (id) => {
    scrollToSection(id);
    setIsMenuOpen(false);
  };

  return (
    <header className="fixed top-0 w-full bg-white/95 backdrop-blur-sm shadow-sm z-50 transition-all duration-300">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          <div className="flex items-center cursor-pointer" onClick={() => handleNav('hero')}>
            <img src="/solvida-logo-new.png" alt="SolVida Financial Logo" className="h-16 w-auto object-contain" />
          </div>

          <nav className="hidden md:flex items-center space-x-6">
            <button onClick={() => handleNav('products')} className="text-slate-700 hover:text-amber-700 font-medium transition-colors duration-200" data-testid="nav-products">
              {t('nav_products')}
            </button>
            <button onClick={() => handleNav('why-us')} className="text-slate-700 hover:text-amber-700 font-medium transition-colors duration-200" data-testid="nav-why-us">
              {t('nav_why_us')}
            </button>
            <button onClick={() => handleNav('contact')} className="text-slate-700 hover:text-amber-700 font-medium transition-colors duration-200" data-testid="nav-contact">
              {t('nav_contact')}
            </button>
            <button
              onClick={toggleLanguage}
              className="flex items-center gap-1.5 text-slate-600 hover:text-amber-700 font-medium transition-colors duration-200 border border-slate-300 rounded-full px-3 py-1.5 text-sm hover:border-amber-500"
              data-testid="language-toggle"
            >
              <Globe className="w-4 h-4" />
              {lang === 'en' ? 'ES' : 'EN'}
            </button>
            <Button onClick={() => handleNav('contact')} className="bg-amber-700 hover:bg-amber-800 text-white px-6 transition-colors duration-200" data-testid="nav-get-started">
              {t('nav_get_started')}
            </Button>
          </nav>

          <div className="flex items-center gap-3 md:hidden">
            <button
              onClick={toggleLanguage}
              className="flex items-center gap-1 text-slate-600 border border-slate-300 rounded-full px-2.5 py-1.5 text-sm"
              data-testid="language-toggle-mobile"
            >
              <Globe className="w-3.5 h-3.5" />
              {lang === 'en' ? 'ES' : 'EN'}
            </button>
            <button className="text-slate-700 hover:text-amber-700 transition-colors duration-200" onClick={() => setIsMenuOpen(!isMenuOpen)} aria-label="Toggle navigation menu" aria-expanded={isMenuOpen}>
              {isMenuOpen ? <X size={28} /> : <Menu size={28} />}
            </button>
          </div>
        </div>

        {isMenuOpen && (
          <div className="md:hidden py-4 border-t border-slate-200 animate-in slide-in-from-top">
            <nav className="flex flex-col space-y-4">
              <button onClick={() => handleNav('products')} className="text-slate-700 hover:text-amber-700 font-medium text-left transition-colors duration-200">
                {t('nav_products')}
              </button>
              <button onClick={() => handleNav('why-us')} className="text-slate-700 hover:text-amber-700 font-medium text-left transition-colors duration-200">
                {t('nav_why_us')}
              </button>
              <button onClick={() => handleNav('contact')} className="text-slate-700 hover:text-amber-700 font-medium text-left transition-colors duration-200">
                {t('nav_contact')}
              </button>
              <Button onClick={() => handleNav('contact')} className="bg-amber-700 hover:bg-amber-800 text-white w-full transition-colors duration-200">
                {t('nav_get_started')}
              </Button>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
